import { render, staticRenderFns } from "./ReadingTypeFlagPill.vue?vue&type=template&id=44a44e76&scoped=true&"
import script from "./ReadingTypeFlagPill.vue?vue&type=script&lang=js&"
export * from "./ReadingTypeFlagPill.vue?vue&type=script&lang=js&"
import style0 from "./ReadingTypeFlagPill.vue?vue&type=style&index=0&id=44a44e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a44e76",
  null
  
)

component.options.__file = "ReadingTypeFlagPill.vue"
export default component.exports